// utilityfunctions.js
export function convert_to_request_parameters(range, startTime, endTime) {
  // Helper to safely convert to Date object
  const toDate = (value) => {
    if (!value) return null;
    if (value instanceof Date) return value;
    if (typeof value === "string") {
      // Try to parse ISO string
      const date = new Date(value);
      if (!isNaN(date.getTime())) return date;
    }
    return null;
  };

  // Convert range dates
  const startDate = toDate(range.startDate);
  const endDate = toDate(range.endDate);

  // Convert time objects
  const startTimeObj = toDate(startTime);
  const endTimeObj = toDate(endTime);

  // Build start date string
  let start_date = "";
  let start_ts = "";
  if (startDate) {
    start_date =
      startDate.getFullYear() +
      "-" +
      (startDate.getMonth() + 1) +
      "-" +
      startDate.getDate();
    if (startTimeObj) {
      start_ts =
        "T" +
        startTimeObj.getHours() +
        "%3A" +
        startTimeObj.getMinutes() +
        "%3A" +
        startTimeObj.getSeconds();
    }
  }

  // Build end date string (endDate is required)
  let end_date = "";
  let end_ts = "";
  if (endDate) {
    end_date =
      endDate.getFullYear() +
      "-" +
      (endDate.getMonth() + 1) +
      "-" +
      endDate.getDate();
    if (endTimeObj) {
      end_ts =
        "T" +
        endTimeObj.getHours() +
        "%3A" +
        endTimeObj.getMinutes() +
        "%3A" +
        endTimeObj.getSeconds();
    }
  }

  const result = {
    start: start_date + start_ts,
    end: end_date + end_ts,
  };
  return result;
}
